var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-btn',{attrs:{"disabled":_vm.isToggleDisabled,"color":_vm.toggleColor,"icon":""},on:{"click":_vm.switchUserState}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)],1)]}}])},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }